export const UNAUTHORIZED_STATUS_CODE_401 = 401;
